// UserSettings.js
const UserSettings = {
    timeFormat: '24h',
    dateFormat: 'DD.MM.YYYY',
    timeZone: 'Europe/Amsterdam',
    maxConnectionRetries: 10000,
    pageSize: 25,
};
export default UserSettings;
